<template>
  <el-dialog
    :visible="true"
    :fullscreen="true"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div slot="title">
      {{ title }}
      <el-tag
        v-if="declutter.status && (type === 'update' || type === 'view')"
        size="small"
        :type="getStatus().tag"
        style="margin-left: 5px;"
      >
        {{ getStatus().label }}
      </el-tag>
    </div>
    <div v-if="type === 'view' && declutter.receipt_number">
      <el-link @click="openReceipt" type="primary" style="margin-bottom: 30px; margin-top: -20px;">
        <i class="el-icon-printer el-icon--right"></i>
        {{ declutter.receipt_number }}
      </el-link>
    </div>
    <div v-loading="loading">
      <el-form
        ref="declutterForm"
        label-position="top"
        :model="declutter"
        :rules="rules"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              prop="supplier"
              label="Szállító"
            >
              <el-select
                v-model="declutter.supplier"
                style="width: 100%;"
                value-key="id"
                filterable
                :disabled="declutter.status !== 'recorded' || type === 'view'"
              >
                <el-option
                  v-for="ownCompany in ownCompanies"
                  :key="ownCompany.id"
                  :value="ownCompany"
                  :label="ownCompany.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="source_storage"
              label="Raktár"
            >
              <el-select
                v-model="declutter.source_storage"
                style="width: 100%;"
                value-key="id"
                filterable
                :disabled="declutter.status !== 'recorded' || type === 'view'"
              >
                <el-option
                  v-for="storage in storages"
                  v-show="storage.type === 'own'"
                  :key="storage.id"
                  :value="storage"
                  :label="storage.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item
              prop="currency"
              label="Deviza"
            >
              <el-select
                v-model="declutter.currency"
                style="width: 100%;"
                value-key="id"
                filterable
                :disabled="declutter.status !== 'recorded' || type === 'view'"
              >
                <el-option
                  v-for="currency in currencies"
                  :key="currency.id"
                  :value="currency"
                  :label="currency.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              prop="completion_date"
              label="Teljesítés dátuma"
            >
              <el-date-picker
                v-model="declutter.completion_date"
                type="date"
                style="width: 100%;"
                :clearable="false"
                format="yyyy. MM. dd."
                value-format="yyyy-MM-dd"
                :picker-options="{ firstDayOfWeek: 1 }"
                :disabled="declutter.status !== 'recorded' || type === 'view'"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              prop="reference_number"
              label="Hivatkozási szám"
            >
              <el-input
                v-model="declutter.reference_number"
                :disabled="declutter.status !== 'recorded' || type === 'view'"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          prop="comment"
          label="Megjegyzés"
        >
          <el-input
            v-model="declutter.comment"
            type="textarea"
            :rows="3"
            :disabled="type === 'view'"
          />
        </el-form-item>
        <product-items
          ref="productItems"
          :storage-id="declutter.source_storage.id"
          :currenc="declutter.currency && declutter.currency.code"
          :default-items="declutter.declutter_items"
          :enabled-elements="enabledElements"
          :enabled-columns="type === 'view' ? ['product', 'productPackType', 'expirationDateSelector', 'count', 'vat', 'declutterReason', 'supplierSelector', 'comment'] : ['product', 'productPackType', 'expirationDateSelector', 'count', 'vat', 'actions', 'declutterReason', 'supplierSelector', 'comment']"
        />
      </el-form>
    </div>
    <div
      v-if="type !== 'view'"
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        :loading="buttonLoading"
        :disabled="declutter.status !== 'recorded'"
        @click="store"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import moment from 'moment';
  import ProductItems from '../../utils/ProductItems/index';

  export default {
    components: {
      ProductItems,
    },
    props: ['type', 'declutterId'],
    data() {
      return {
        loading: false,
        buttonLoading: false,
        products: null,
        declutter: {
          status: 'recorded',
          supplier: {},
          declutter_items: [],
          source_storage: {},
          receiver_storage: {},
          currency: {},
        },
        rules: {
          source_storage: [
            {
              required: true,
              message: 'Raktár kiválasztása kötelező',
              trigger: 'change'
            }
          ],
          supplier: [
            {
              required: true,
              message: 'Szzállító kiválasztása kötelező',
              trigger: 'change'
            }
          ],
          currency: [
            {
              required: true,
              message: 'Deviza kiválasztása kötelező',
              trigger: 'change'
            }
          ],
          comment: [
            {
              required: true,
              message: 'Érték megadása kötelező',
              trigger: 'change'
            }
          ],
          reference_number: [
            {
              required: true,
              message: 'Érték megadása kötelező',
              trigger: 'change'
            }
          ],
        },
      };
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új selejtezés';
        } else if (this.type === 'update') {
          return 'Selejtezés módosítása';
        } else if (this.type === 'view') {
          return 'Selejtezés megtekintése';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadása';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
      enabledElements() {
        if(this.type === 'view') {
          return [];
        }
        switch (this.declutter.status) {
          case 'recorded':
            return ['addButton', 'deleteButton', 'product', 'pack', 'count', 'vat', 'expirationDateSelector', 'declutterReason', 'supplierSelector', 'comment'];
          case 'completed':
            return [];
          case 'cancelled':
            return [];
          default:
            return [];
        }
      },
      ownCompanies() {
        return this.$store.getters['ownCompany/ownCompanies'];
      },
      storages() {
        return this.$store.getters['storage/storages'];
      },
      currencies() {
        return this.$store.getters['currency/currencies'];
      },
    },
    async mounted() {
      this.loading = true;
      await Promise.all([
        this.$store.dispatch('ownCompany/fetchAll'),
        this.$store.dispatch('storage/fetchAll', ''),
        this.$store.dispatch('currency/fetchAll'),
        this.$store.dispatch('vat/fetchAll'),
      ]);
      if (this.declutterId) {
        this.declutter = await this.$store.dispatch('declutter/fetch', this.declutterId);
      } else {
        this.declutter.supplier = this.ownCompanies[0];
        this.declutter.currency = this.currencies[0];
        this.declutter.source_storage = this.storages.find(s => s.type === 'own');
        this.declutter.completion_date = moment()
        .add(3, 'days')
        .format('Y-MM-DD');
      }
      this.loading = false;
    },
    methods: {

      handleClose() {
        if(this.type === 'view') {
          return this.$router.replace('/processes/declutters');
        }
        this.$confirm('Biztosan elveted a módosításokat?', {
          confirmButtonText: 'Igen',
          type: 'warning',
        })
        .then(() => {
          this.$router.replace('/processes/declutters');
        })
        .catch(() => {
        });
      },

      async store() {
        this.$refs.declutterForm.validate(async valid => {
          const expValid = this.$refs['productItems'].validateExpirationDates();
          const supplierValid = this.$refs['productItems'].validateSuppliers();
          if (!expValid || !supplierValid || !valid) {
            this.$messageWrapper.warning('Hibásan kitöltött form.');
            return;
          }
          if (valid) {
            this.declutter.declutter_items = this.$refs['productItems'].getItems();
            if (!this.declutter.declutter_items.length) {
              return this.$messageWrapper.warning('Minimum 1 termék hozzáadása kötelező.');
            }
            this.buttonLoading = true;
            try {
              if (this.type === 'add') {
                await this.$store.dispatch('declutter/create', this.declutter);
              } else if (this.type === 'update') {
                await this.$store.dispatch('declutter/update', this.declutter);
              }
              this.$store.dispatch('declutter/fetchAll');
              this.buttonLoading = false;
              this.$router.replace('/processes/declutters');
            } catch (e) {
            }
            this.buttonLoading = false;
          }
        });
      },
      getStatus() {
        switch (this.declutter.status) {
          case 'recorded':
            return {
              label: 'Rögzítve',
              tag: 'info',
            };
          case 'cancelled':
            return {
              label: 'Érvénytelenítve',
              tag: 'danger',
            };
          case 'completed':
            return {
              label: 'Teljesített',
              tag: 'success',
            };
        }
      },
      openReceipt() {
        if (this.declutter.receipt_file && this.declutter.receipt_file.path) {
          window.open(this.declutter.receipt_file.path);
        }
      },
    },
  };
</script>

<style lang="scss">
  .price-sum {
    margin-top: 20px;
    text-align: right;
    font-size: 18px;

    > div {
      display: inline-block;
    }
  }
</style>
